import { render, staticRenderFns } from "./TagListing.vue?vue&type=template&id=9e2a317c&scoped=true&"
import script from "./TagListing.vue?vue&type=script&lang=js&"
export * from "./TagListing.vue?vue&type=script&lang=js&"
import style0 from "./TagListing.vue?vue&type=style&index=0&id=9e2a317c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2a317c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e2a317c')) {
      api.createRecord('9e2a317c', component.options)
    } else {
      api.reload('9e2a317c', component.options)
    }
    module.hot.accept("./TagListing.vue?vue&type=template&id=9e2a317c&scoped=true&", function () {
      api.rerender('9e2a317c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/TagListing.vue"
export default component.exports